import SegmentUtils from 'utils/segment';

export default function trackShowMobileSearchMapView() {
    const properties = {};

    SegmentUtils.track({
        event: 'Show Mobile Search Map View',
        properties,
        additionalOptions: {
            context: {
                protocols: {
                    event_version: 1,
                },
            },
        },
    });
}
